<template>
  <div
    class="hover:border-primary-60 border-neutral-90 relative overflow-hidden rounded-md border-2 bg-white hover:cursor-pointer hover:shadow-md"
    @click="selectTemplate()"
  >
    <div class="text-neutral-80 mx-2 flex h-[350px] flex-col justify-center space-y-3">
      <PlusIcon class="mx-auto h-6 w-6" />
      <SimpleButton theme="primary-light" class="pointer-events-none mx-auto w-max">{{
        t("newTemplateButton")
      }}</SimpleButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
//Icons
import { PlusIcon } from "@heroicons/vue/solid";

//Components
import SimpleButton from "@atoms/SimpleButton.vue";

//Utils
import { useI18n } from "vue-i18n";

const { t } = useI18n();

// Emits
const emit = defineEmits<{
  (e: "select"): void;
}>();

const selectTemplate = () => emit("select");
</script>

<i18n lang="jsonc">
{
  "es": {
    "newTemplateButton": "Plantilla vacía",
  },
  "pt": {
    "newTemplateButton": "Template vazio",
  },
}
</i18n>
